import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { castDraft } from "immer";

import { ISyncStoreID } from "../../models/nominals";
import { defaults } from "./defaults";
import { StoreSearchFilters } from "./models";
import { loadClosestStores } from "./thunks";

export const retailSlice = createSlice({
    name: "retail",
    initialState: defaults,
    reducers: {
        updateStoreFilters: (
            state,
            action: PayloadAction<Partial<StoreSearchFilters>>,
        ) => {
            state.storeFilters = castDraft({
                ...state.storeFilters,
                ...action.payload,
            });
        },

        setFocusedStore: (
            state,
            action: PayloadAction<{
                externalID: ISyncStoreID | null;
            }>,
        ) => {
            state.focusedStoreID = action.payload.externalID;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadClosestStores.pending, () => {
                // Loading state could be added here in the future if needed
            })
            .addCase(loadClosestStores.fulfilled, (state, action) => {
                // Sort stores by distance
                const sortedStores = [...action.payload.stores].sort((a, b) => {
                    if (a.distance === b.distance) {
                        return 0;
                    }
                    return a.distance > b.distance ? 1 : -1;
                });
                state.stores = castDraft(sortedStores);
                if (action.payload.loadKey) {
                    state.storesLoadedKey = action.payload.loadKey;
                }
            })
            .addCase(loadClosestStores.rejected, () => {
                // Error handling could be added here in the future if needed
            });
    },
});

export const { updateStoreFilters, setFocusedStore } = retailSlice.actions;
